import { render, staticRenderFns } from "./TeamChatDetailHeader.vue?vue&type=template&id=a02bad7a"
import script from "./TeamChatDetailHeader.vue?vue&type=script&lang=js"
export * from "./TeamChatDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./TeamChatDetailHeader.vue?vue&type=style&index=0&id=a02bad7a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports